<template>
    <Layout class="bg-white"
        :header="{ text: titleText, backBtn: { visible: false }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-8">
            <div class="pb-4 text-center">
                <div class="inline-block">
                    <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_755_21211)">
                            <rect x="21.3271" y="52.1768" width="56.6171" height="10"
                                transform="rotate(-45 21.3271 52.1768)" fill="#70E1F2" />
                            <rect width="30" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#70F2D0" />
                            <rect width="10" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#11699C" />
                        </g>
                        <defs>
                            <clipPath id="clip0_755_21211">
                                <rect width="72" height="72" fill="white" transform="translate(0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <h2 class="font-bold text-2xl">委託受理完成</h2>
            </div>
            <!-- <div v-if="isQuickTransfer" class="text-md">
                <p class="pb-2">
                    本次申請金額預計 1 個小時內可匯入您的帳戶，惟仍可能因以下情形而有調整：
                </p>
                <ol class="list-decimal pl-5">
                    <li>您的帳戶資訊有誤或因戶名難字或其他原因致銀行無法接收。</li>
                    <li>申請交易時間已逾當日匯款時間，則於次一營業日匯款。</li>
                </ol>
            </div>
            <div v-else class="text-md">
                <p class="pb-4">
                    為保障保戶權益，於審理必要時會電話聯繫您已確認本次交易，並於完成聯繫及審核後，預計於 113 年 5 月 28 日完成匯款。
                </p>
                <p>
                    請保持保單聯絡電話暢通，以避免影響匯款時效。本公司將持續聯繫三個營業日，若無法與您聯繫，將取消本次保單借款申請。
                </p>
            </div> -->
            <div class="text-md">
                <div v-html="noticeMsg" />
            </div>
        </div>
        <div class="pb-6">
            <div class="flex items-end pb-4">
                <h3 class="flex-1 font-bold text-xl">申請紀錄</h3>
                <button class="pt-3 text-sm text-[#0093C1]" @click="download">
                    <svg class="inline-block" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.66699 8V11.3333C2.66699 12.0697 3.26395 12.6667 4.00033 12.6667H7.01088H12.0003C12.7367 12.6667 13.3337 12.0697 13.3337 11.3333V8"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" />
                        <path d="M5.33301 6.66667L7.99967 9.58203M7.99967 9.58203L10.6663 6.66667M7.99967 9.58203V2"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    下載
                </button>
            </div>
            <CaseBox :hasShadow="false" :caseBox="record"></CaseBox>
        </div>
        <ul v-if="aplCatl === aplCatlCode.LOAN" class="list-disc pl-6 text-sm">
            <li class="pb-2">本次受理案號申請內容為加密之PDF檔，密碼為您登入時之要保人身分證字號(大小寫視為不同字母) 。</li>
            <li class="pb-2">若您對於本次借款申請有任何疑問，請撥打本公司客戶服務專線 0809-026-688 洽詢。</li>
        </ul>
        <ul v-else class="list-disc pl-6 text-sm">
            <li class="pb-2">本次受理案號申請內容為加密之PDF檔，密碼為您登入時之要保人身分證字號(大小寫視為不同字母) 。</li>
            <li class="pb-2">若欲查詢保單變更處理進度，請點選【查詢/取消預約資料】查詢。</li>
            <li class="pb-2">若您對於本次變更申請有任何疑問，請撥打本公司客戶服務專線 0809-000-550 洽詢。</li>
        </ul>
        <template v-slot:bottom>
            <div class="footer-shadow">
                <div class="flex w-full px-2 py-3 max-w-[768px] mx-auto">
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                            :to="{ name: routeName.CLOUD_E_COUNTER_HOME, params: { tab: 1 } }">
                            查看申請進度
                        </RouterLink>
                    </div>
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#0093C1] text-white"
                            :to="{ name: routeName.CLOUD_COUNTER_HOME }" replace>
                            回首頁
                        </RouterLink>
                    </div>
                </div>
            </div>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import Layout from '@/components/cloudCounter/Layout.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';
import { getCompleteReserveApply } from '@/apis/system';
import { getCecPdfRecordToken } from '@/apis/record.js';
import aplCatlCode from '@/json/aplCatlCode';

const storedData = ref(null);
// const isQuickTransfer = ref(false);
const isVideoReserved = ref(false);
const isLoading = ref(false);
const noticeMsg = ref('');
const store = useStore();
const titleText = ref('');

const todayRoc = computed(() => {
    const dateStr = new Date().toJSON().slice(0, 10).split('-');
    const year = `${parseInt(dateStr[0]) - 1911}`;
    return `${year}/${dateStr[1]}/${dateStr[2]}`;
});

const aplCatl = computed(() => store.state.services.aplCatl);
if (aplCatl.value === aplCatlCode.LOAN) {
    titleText.value = '保單借款'
} else {
    titleText.value = '受益人變更'
}

const record = ref({
    boxList: [{
        flexClass: 'justify-between',
        list: [
            { key: '申請項目', value: '' },
            { key: '申請日期', value: todayRoc.value },
            { key: '受理案號', value: '' }
        ]
    }]
});

const initData = async () => {
    isLoading.value = true;
    try {
        const res = await getCompleteReserveApply();
        storedData.value = res.data;
        // isQuickTransfer.value = res.data?.quickTransfer;
        isVideoReserved.value = res.data?.videoReserved;
        noticeMsg.value = res.data?.importantMsg;
        record.value = {
            boxList: [{
                flexClass: 'justify-between',
                list: [
                    { key: '申請項目', value: res.data?.aplCatlText },
                    { key: '申請日期', value: todayRoc.value },
                    ...(res.data?.fullPolicyNo ? [{ key: '保單號碼', value: res.data?.fullPolicyNo },] : []),
                    { key: '受理案號', value: res.data?.regiNo }
                ]
            }]
        }
    } catch (ex) { } finally {
        isLoading.value = false;
    }
}
initData();

const download = () => {
    isLoading.value = true;
    getCecPdfRecordToken(storedData.value?.regiNo).then((response) => {
        const token = response.data.token;
        const path = process.env.VUE_APP_CONTEXT_PATH;
        const baseUrl = `${window.location.origin}${path}`;
        console.log(`${baseUrl}/api/transaction/record/downloadCECPdf?token=${token}`, '_blank');
        window.open(`${baseUrl}/api/transaction/record/downloadCECPdf?token=${token}`, '_blank');
    }).finally(() => {
        setTimeout(() => {
            isLoading.value = false;
        }, 500);
    });
};
</script>
<style scoped>
.footer-shadow {
    box-shadow: 0px -4px 12px 0px #0C0E1F0A;
}
</style>
